module.exports = __webpack_public_path__ + "fonts/Nexa Bold.c9f309b3.otf";